export default {
    topics: [
        {
            title: ' CheckRights ',
            href: 'sm-operator-CheckRights.html',
            attributes: { 'data-id': 'sm-operator-CheckRights' },
            menu: { hasChildren: false },
            tocID: 'sm-operator-CheckRights-d66e1036',
            topics: [],
        },
        {
            title: ' ResetPassword ',
            href: 'sm-operator-ResetPassword.html',
            attributes: { 'data-id': 'sm-operator-ResetPassword' },
            menu: { hasChildren: false },
            tocID: 'sm-operator-ResetPassword-d66e1044',
            topics: [],
        },
    ],
};

